import { tns } from 'tiny-slider/src/tiny-slider';
import whenDomReady from 'when-dom-ready';

function initialise() {
  const carousels = Array.from(document.querySelectorAll('.js-ds-carousel'));

  carousels.forEach(initialiseCarousel);
}

/**
 * Initialise carousel.
 * @param {HTMLElement} carousel
 */
function initialiseCarousel(carousel) {
  tns({
    container: carousel,
    controlsText: [
      `<svg viewBox="0 0 19.883 14.948"><use xlink:href="/SiteFiles/src/img/icons/icon-arrow.svg#icon-arrow" /></svg>`,
      `<svg viewBox="0 0 19.883 14.948"><use xlink:href="/SiteFiles/src/img/icons/icon-arrow.svg#icon-arrow" /></svg>`,
    ],
    gutter: 24,
    items: 1,
    loop: false,
    nav: false,
    responsive: {
      600: {
        items: 2,
      },
      820: {
        items: 3,
      },
      992: {
        items: 3,
      },
      1240: {
        items: 2,
      },
      1366: {
        items: 3,
      },
    },
    slideBy: 'page',
    speed: 600,
  });

  const buttonsContainer = Array.from(document.querySelectorAll('.tns-controls'));
  buttonsContainer.forEach(container => {
    const ctlButtons = Array.from(container.querySelectorAll('button'));
    ctlButtons.forEach(button => {
      button.setAttribute('type', 'button');
    });
  });
}

whenDomReady().then(initialise);
